const cleanRut = (rut: string): string => {
  const cleanedRut = rut
    .trim()
    .replace(/[^0-9kK]/g, '')
    .toLowerCase();

  return cleanedRut;
};

export { cleanRut };
